export const STAGGER_DELAY = 0.1;

export const INITIAL_ANIMATION = {
  opacity: 0,
  y: 20,
};

export const ANIMATE_IN = {
  opacity: 1,
  y: 0,
};

export const SECTION_TRANSITION = {
  duration: 0.5,
  ease: "easeOut" as const,
};
